// extracted by mini-css-extract-plugin
export default {"otpInputFields":"style_otpInputFields__IEkEZ","consentOtpInputFields":"style_consentOtpInputFields__jieEy","continueBtnBox":"style_continueBtnBox__KoLJY"};